import { Divider } from '@reveni-io/reveni-ui'

import { hasRecommendation, hasRecommendationGlobal } from '@/metrics/helpers/helpers'

import SizingIssuesAlert from '../SizingIssuesAlert/SizingIssuesAlert'
import SizingIssuesCountries from '../SizingIssuesCountries/SizingIssuesCountries'
import SizingIssuesRegions from '../SizingIssuesRegions/SizingIssuesRegions'
import SizingIssuesTitle from '../SizingIssuesTitle/SizingIssuesTitle'
import * as Styles from './styles'

const SizingIssuesTooltip = ({ recommendation, recommendationGlobal }) => {
  const showAllRegions = hasRecommendationGlobal(recommendationGlobal)
  const showCountries = hasRecommendation(recommendation)

  return (
    <Styles.Container>
      <SizingIssuesTitle />
      {showAllRegions && <SizingIssuesRegions recommendationGlobal={recommendationGlobal} />}
      {showAllRegions && showCountries && <Divider />}
      {showCountries && <SizingIssuesCountries recommendation={recommendation} />}
      <SizingIssuesAlert />
    </Styles.Container>
  )
}

export default SizingIssuesTooltip
